module.exports = __webpack_public_path__ + "img/ic-system-update.16c1c835.svg";